import { render, staticRenderFns } from "./TheQuiz.vue?vue&type=template&id=263519ee&"
import script from "./TheQuiz.vue?vue&type=script&lang=js&"
export * from "./TheQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports